export default __webpack_public_path__ + "static/media/640_dummy2016-moebelbauer01-de.cb280d9a.png";